import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useI18n } from "@/i18n/I18nProvider";

export const GdprBanner = () => {
  const { t } = useI18n();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("punchink_gdpr")) setShow(true);
  }, []);

  const decide = (v: "accept" | "decline") => {
    localStorage.setItem("punchink_gdpr", v);
    setShow(false);
  };

  if (!show) return null;
  return (
    <div className="fixed bottom-4 inset-x-4 md:inset-x-auto md:right-6 md:max-w-md z-50 rounded-xl border border-neon-green/40 bg-card/95 backdrop-blur-xl p-4 shadow-2xl glow-green">
      <p className="text-sm text-foreground/90 mb-3">
        {t("gdpr.text")}{" "}
        <Link to="/cookies" className="underline text-neon-green">
          {t("footer.cookies")}
        </Link>
      </p>
      <div className="flex gap-2">
        <Button size="sm" onClick={() => decide("accept")} className="bg-neon-green text-background hover:bg-neon-green/90 font-bold flex-1">
          {t("gdpr.accept")}
        </Button>
        <Button size="sm" variant="outline" onClick={() => decide("decline")} className="flex-1">
          {t("gdpr.decline")}
        </Button>
      </div>
    </div>
  );
};
